<template>
  <div class="hero home-hero">
    <div class="bg-line container"></div>
    <div class="slider-overlay">
      <slick ref="slick" :options="slickOptions" dir="rtl">
        <div
          v-for="item in sliderInfo.slider.slides"
          :key="item.id"
          :style="{ backgroundImage: 'url(' +  item.imageUrl + ')' }"
        >
          <div class="content container">
            <div>
              <h2>{{item.description}}</h2>
            </div>
          </div>
        </div>
      </slick>
    </div>
    <div class="main-news">
      <div class="news-list horizontal home">
        <News v-for="item in news" :item="item" :key="item.id"></News>
      </div>
    </div>
  </div>
</template>
<script>
import Slick from "vue-slick";
const News = () => import("@/components/shared/News.vue");

const url = process.env.VUE_APP_URL;

export default {
  data() {
    return {
      sliderInfo: [],
      slickOptions: {
        slidesToShow: 1,
        rtl: true,
        dots: true,
        arrows: false,
        speed: 1500,
        easing: "cubic-bezier(.6,0,.22,1)",
      },
    };
  },
  computed: {
    news() {
      var news = this.$store.getters.mainNews;
      return news;
    },
  },
  methods: {
    slider() {
      var slider = JSON.parse(JSON.stringify(this.$store.getters.homePage));
      this.sliderInfo = slider;
    },
    homePage() {
      this.axios
        .get(url + "/home_pages", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          this.$store.dispatch("homePage", payload);
          this.slider();
        });
    },
    mainNews() {
      this.axios
        .get(url + "/articles?isMain=true", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          return this.$store.dispatch("mainNews", payload);
        });
    },
  },
  mounted() {
    this.mainNews();
    this.homePage();
  },
  components: {
    Slick,
    News,
  },
};
</script>
<style lang="scss" scoped>
$orange: #fbbb00;
.slider-overlay {
  padding-left: calc((100vw - 117rem) / 2);
  height: 100%;
  @media only screen and (max-width: 1199px) {
    padding-left: 0;
  }
  @media only screen and (max-width: 992px) {
  }
}
.hero {
  position: relative;
  height: calc(100vh - 8rem);
  min-height: 50rem;
  overflow: hidden;
  @media only screen and (max-width: 992px) {
    max-height: 60rem;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    position: relative;
    height: 100%;
    margin: 0 auto 0 0;
    padding-top: 23rem;
    @media only screen and (max-width: 1399px) {
      padding-top: 12rem;
    }
    @media only screen and (max-width: 1199px) {
      margin: 0 auto;
    }
    @media only screen and (max-width: 992px) {
      padding-top: 7rem;
    }
    @media only screen and (max-width: 768px) {
      padding-bottom: 18rem;
      justify-content: flex-end;
    }
    div {
      padding-left: 6.5rem;
      padding-right: 5rem;
      position: relative;
      //overflow: hidden;
      &:before {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        width: 3px;
        height: 100%;
        background: $orange;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        z-index: 3;
        //opacity: 0;
        transition: all 0.01s ease-out 0.8s;
      }
      @media only screen and (max-width: 992px) {
        padding-left: 3rem;
      }
      @media only screen and (max-width: 499px) {
        padding-left: 2rem;
      }
    }
    & > * {
      position: relative;
      z-index: 2;
    }
    &:after {
      position: absolute;
      top: 23rem;
      left: 0;
      content: "";
      width: 3px;
      height: 100%;
      transform: translateY(100%);
      background: $orange;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      z-index: 1;
      @media only screen and (max-width: 1399px) {
        top: 12rem;
      }
      @media only screen and (max-width: 992px) {
        top: 7rem;
      }
      @media only screen and (max-width: 768px) {
        top: 15rem;
      }
    }
    h2 {
      position: relative;
      text-align: left;
    }
  }
}
.hero {
  .main-news {
    width: 51%;
    max-width: 100rem;
    position: absolute;
    right: 7.5rem;
    bottom: 12.5%;
    z-index: 5;
    @media only screen and (max-width: 1599px) {
      width: 54%;
    }
    @media only screen and (max-width: 1199px) {
      right: 5%;
      width: 70%;
    }
    @media only screen and (max-width: 992px) {
      right: calc((100% - 78rem) / 2);
      width: 50%;
      max-width: 44rem;
    }
    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
}
</style>
